import {
  CubeReducerState,
  ValidationResult
} from 'modules/Cube/domain/cube.domain.types'

export const atLeastOneContact = (
  prevState: CubeReducerState
): ValidationResult[] | null => {
  const recipientCount =
    prevState.data.quote.contacts.length +
    prevState.data.quote.ccContacts.length

  if (recipientCount > 0) {
    return null
  }

  return [{ message: 'At least one recipient is required' }]
}
